<script>
/**
 * ****************************************************************************
 * @description     :   Footer
 * @created at      :   2022/06/20
 * @created by      :   ANS – baonx@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState } from 'vuex';
import _ from 'lodash';
import helpers from '@/utils/helpers';

/**
 * import template
 */
import template from './template.html';
import { MobileFooter, NeedMoreCheck } from '@/shared/menu/menu';

/**
 * Define main layout
 */
const Footer = {
    name: 'Menu',
    template: template,
    components: {},
    data() {
        return {
            menus: [...MobileFooter],
            permission: helpers.permission()
        };
    },
    computed: {
        ...mapState('app', [
            'menuPermission',
            'notification',
            'screenId',
            'isMobile',
            'user'
        ]),
        itemStyle() {
            let count = _.filter(this.menus, (x) => {
                return x.hadPermission;
            }).length;
            return {
                width: `${100.0 / (count > 0 ? count : 1)}%`
            };
        }
    },
    watch: {
        menuPermission() {
            setTimeout(() => {
                this.checkPermission();
                this.setActiveItem();
            }, 100);
        },
        user() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.checkPermission();
            }, 100);
        },
        'user.switchUser'() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.checkPermission();
            }, 100);
        },
        screenId() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        },
        isMobile() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        }
    },
    mounted() {
        setTimeout(() => {
            this.permission = helpers.permission();
            this.checkPermission();
            this.setActiveItem();
        }, 100);
    },
    methods: {
        setActiveItem() {
            const length = this.menus.length;
            const pathname =
                window.location.pathname === '/'
                    ? ''
                    : window.location.pathname;
            for (let i = 0; i < length; i++) {
                if (this.menus[i].url === pathname) {
                    this.menus[i].isActive = true;
                } else {
                    this.menus[i].isActive = false;
                }
            }
        },
        checkPermission() {
            const length = this.menus.length;
            for (let i = 0; i < length; i++) {
                if (this.menus[i].role.includes(this.permission)) {
                    this.menus[i].hadPermission = true;
                    if (
                        NeedMoreCheck[this.permission]?.includes(
                            this.menus[i].id
                        )
                    ) {
                        const per = _.findLast(this.menuPermission, {
                            機能ID: this.menus[i].id
                        });
                        if (
                            !(
                                per &&
                                ((this.menus[i].isCheck利用者権限 &&
                                    per.利用者権限 == 1) ||
                                    (!this.menus[i].isCheck利用者権限 &&
                                        per.上司権限 == 1))
                            )
                        ) {
                            this.menus[i].hadPermission = false;
                        }
                    }
                } else {
                    this.menus[i].hadPermission = false;
                }
            }
        },
        haveNotification(item) {
            return (
                (item.id == 'Gm0060v' &&
                    this.notification.本人アラート件数 &&
                    this.notification.本人アラート件数 > '0') ||
                (item.id == 'Gm0080v' &&
                    this.notification.アラート件数 &&
                    this.notification.アラート件数 > '0') ||
                (item.id == 'Gm0070i' &&
                    this.notification.承認待ち件数 &&
                    this.notification.承認待ち件数 > '0')
            );
        },
        getNotification(item) {
            // eslint-disable-next-line prettier/prettier
            return item.id == 'Gm0060v' ? this.notification.本人アラート件数 : item.id == 'Gm0070i' ? this.notification.承認待ち件数 : this.notification.アラート件数;
        }
    }
};
export default Footer;
</script>
